module.exports = __webpack_public_path__ + "static/PortofolioWebsie-5eed65a1ac916b4c87a4bdae7a1e55b0.png";